import { render } from "./ProProdutosView.vue?vue&type=template&id=6fae38ae&scoped=true"
import script from "./ProProdutosView.vue?vue&type=script&lang=js"
export * from "./ProProdutosView.vue?vue&type=script&lang=js"

import "./ProProdutosView.vue?vue&type=style&index=0&id=6fae38ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fae38ae"]])

export default __exports__